// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { ExternalProviderLinkModel } from "@insite/client-framework/Services/IdentityService";
import {
    chain,
    RedirectToExternalProvider,
} from "@insite/client-framework/Store/Context/Handlers/SignInExternalProvider";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ externalProvider: ExternalProviderLinkModel }>;

// Strip GA/tracking params that contain `*` delimiters — `encodeURIComponent` does not
// encode `*` and those characters break OWIN's external-authentication state validation.
export const StoreRedirectToExternalProvider: HandlerType = ({ parameter: { externalProvider }, getState }) => {
    if (!externalProvider.url) {
        return;
    }

    const signInUrl = getPageLinkByPageType(getState(), "SignInPage")?.url;
    const location = getLocation(getState());

    let returnUrl = "/";
    if (signInUrl && location.pathname.toLowerCase() === signInUrl.toLowerCase()) {
        const rawReturnUrl = parseQueryString<{ returnUrl?: string }>(location.search).returnUrl || "/";
        returnUrl = stripTrackingParams(rawReturnUrl);
    } else {
        returnUrl = stripTrackingParams(`${location.pathname}${location.search}`);
    }

    returnUrl = `${returnUrl + (returnUrl.indexOf("?") > -1 ? "&" : "?")}forcereturnurl`;
    // `encodeURIComponent` intentionally leaves `*` unencoded; encode it explicitly.
    returnUrl = encodeURIComponent(returnUrl).replace(/\*/g, "%2A");

    window.location.href = externalProvider.url.replace("returnurl%3a%2f", `returnurl%3a${returnUrl}`);
};

/** Removes Google Analytics / cross-domain tracking query parameters from a URL. */
function stripTrackingParams(url: string): string {
    try {
        const parsed = new URL(url, "https://x");
        const keysToDelete = Array.from(parsed.searchParams.keys()).filter(
            key => key === "_gl" || key.startsWith("_ga") || key.startsWith("_gcl") || key.startsWith("_fplc"),
        );
        keysToDelete.forEach(key => parsed.searchParams.delete(key));
        const search = parsed.searchParams.toString();
        return parsed.pathname + (search ? `?${search}` : "");
    } catch {
        return url;
    }
}

replaceInChain(chain, RedirectToExternalProvider, StoreRedirectToExternalProvider);

const signInExternalProvider = createHandlerChainRunner(chain, "SignInExternalProvider");
export default signInExternalProvider;
